import React from 'react'

import { Table } from 'antd';

import { EmptyPersonalizado } from '../../components/EmptyPersonalizado';
import { useBachilleratos } from '../../hooks/adminexamen/useBachilleratos'

const Bachilleratos = () => {

  const { columns, bachilleratos, loading } = useBachilleratos()

  return (
    <div>

      {/* <NuevoBachillerato/> */}

      <Table
        loading={ loading }
        columns={ columns }
        rowKey="pk_bachillerato"
        showSorterTooltip={ false }
        dataSource={ bachilleratos }
        locale={{ emptyText: <EmptyPersonalizado/> }}
      />
    </div>
  )
}

export default Bachilleratos
